import React from 'react';
import { SpringGrid } from 'react-stonecutter';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import './index.css';
import ourworks from './ourworks.json';

import taxi from '../../images/portfolio/promo-306.jpg';
import anetworkWeb from '../../images/portfolio/promo-anetwork-web.jpg';
import anetwork from '../../images/portfolio/promo-anetwork.jpg';
import fragaria from '../../images/portfolio/promo-fragaria.jpg';
import iptelephony from '../../images/portfolio/promo-iptelephony.jpg';
import lovelook from '../../images/portfolio/promo-lovelook.jpg';
import portal from '../../images/portfolio/promo-portal.jpg';
import pregnancy from '../../images/portfolio/promo-pregnancy.jpg';
import radar from '../../images/portfolio/promo-radar.jpg';
import rasaBord from '../../images/portfolio/promo-rasa-bord.jpg';
import rasaSport from '../../images/portfolio/promo-rasasport.jpg';
import space from '../../images/portfolio/promo-space.jpg';
import sonder from '../../images/portfolio/promo-sonder.jpg';
import tender from '../../images/portfolio/promo-tender.jpg';
import travel from '../../images/portfolio/promo-travel.jpg';
import velovod from '../../images/portfolio/promo-velovod.jpg';
import willy from '../../images/portfolio/promo-willy.jpg';
import zg from '../../images/portfolio/promo-zg.jpg';
import hotel from '../../images/portfolio/promo-hotel.jpg';
import evrent from '../../images/portfolio/promo-evrent.jpg';
import viralvault from '../../images/portfolio/promo-viralvault.jpg';

const imagePort = [
  anetwork,
  sonder,
  zg,
  taxi,
  anetworkWeb,
  willy,
  fragaria,
  iptelephony,
  lovelook,
  portal,
  pregnancy,
  radar,
  rasaBord,
  rasaSport,
  space,
  tender,
  travel,
  velovod,
  hotel,
  evrent,
  viralvault
];

const availablePresentations = [
  'Anetwork',
  'Willy',
  'Zimbara Goromi',
  'Fragaria',
  'Такси 306',
  'Love look',
  'Radar movie',
  'Rasa visual board',
  'Sonder',
  'IP telephony',
  'inTender',
  'Travel life',
  'Hotel Pro',
  'EvRent',
  'Viral Vault'
]

const ourworksPortfolio = ourworks.map((work, index) => {
  return Object.assign({}, work, { photo: imagePort[index] })
})

class WorkPortfolio extends React.Component {
  state = {
    columns: 2,
    columnWidth: 581,
    gutterWidth: 20,
    itemHeight: 305,
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let cw = nextProps.clientWidth;
    if (cw <= 414) {
      return {
        columns: 1,
        columnWidth: 280,
        gutterWidth: 20,
        itemHeight: 163
      }
    }
    else if (cw <= 768 && cw >= 415) {
      return {
        columns: 1,
        columnWidth: 400,
        gutterWidth: 20,
        itemHeight: 211
      }
    }
    else if (cw <= 1200) {
      return {
        columns: 2,
        columnWidth: 364,
        gutterWidth: 15,
        itemHeight: 194
      }
    } else {
      return {
        columns: 2,
        columnWidth: 581,
        gutterWidth: 20,
        itemHeight: 305
      }
    }
  }

  handleWorksFilters = (filter) => {
    return filter === 'all' ? ourworksPortfolio : ourworksPortfolio.filter(work => {
      return work.type.indexOf(filter) !== -1;
    });
  }
  handleWorkTypes(types) {
    if (types.length === 1) {
      return types[0]
    }
    else if (types.length === 2) {
      return (
        types[0] + " / " + types[1]
      )
    }
  }

  render() {
    return (
      <div className="work__content">
        <SpringGrid
          component="ul"
          columns={this.state.columns}
          columnWidth={this.state.columnWidth}
          gutterWidth={this.state.gutterWidth}
          gutterHeight={25}
          itemHeight={this.state.itemHeight}
          springConfig={{ stiffness: 170, damping: 26 }}
        >
          {this.handleWorksFilters(this.props.type).map(work => ((
            availablePresentations.indexOf(work.title) === -1 ?
            <div className="work"
            style={{ cursor: 'auto' }}
            >
              <img className="work__img" src={work.photo} alt="anetwork mobile" />
              <h2 className="work__title">{work.title}</h2>
              <p className="work__subtitle">{this.handleWorkTypes(work.type)}</p>
            </div>
            :
            <div>
              <Link
                className="work"
                key={work.id}
                // style={{
                //   cursor: availablePresentations.indexOf(work.title) !== -1 ? 'pointer' : 'auto'
                // }}
                to={`/portfolio/${work.title}`}>
                <img className="work__img" src={work.photo} alt="anetwork mobile" />
                <h2 className="work__title">{work.title}</h2>
                <p className="work__subtitle">{this.handleWorkTypes(work.type)}</p>
              </Link>
            </div>
          )))}
          <a href="#formidea"> 
            <div className="work">
                <p className="work__seemore">{localStorage.getItem('lang') == 'ru'? 'See more':'See more'}</p>
                <h2 className="work__projects">{localStorage.getItem('lang') == 'ru'? '80+ Projects':'80+ Projects'}</h2>
            </div>
          </a>
        </SpringGrid>
      </div>
    )
  }
}


const mapStateToProps = ({ clientWidth }) => {
  return {
    clientWidth
  }
}

export default connect(mapStateToProps, null)(WorkPortfolio);



// WEBPACK FOOTER //
// ./src/components/workPortfolio/index.jsx